<template>
  <div class="tip-modal" v-show="visible">
    <div class="mask" @click="visible = false"></div>
    <div class="container">
      <div class="header">
        <div class="title">{{ title }}</div>
        <div class="close-btn" @click="visible = false">
          <i class="iconfont iconcha"></i>
        </div>
      </div>
      <div class="tip-content-ul" id="tipContent">
        <div class="agreement-body" v-if="mode === 'privacy'">
          <div>
            <span
              >（一）除司法机关或其他有权机关依法要求提交个人资料外，未经用户的同意，“小包公”不会擅自披露或改变用户的个人信息及使用方式。</span
            >
          </div>
          <div>
            <span
              >（二）“小包公”尊重并致力于保护用户的隐私权，但在“小包公”注册或使用某些服务时，用户需提交个人身份验证信息（包括但不限于您的姓名、地址、职业、电子邮件地址、电话号码等），以便于我们核实您是否有资格使用“小包公”所提供的某些信息、资料或服务，以及能更好的提供客户服务和技术支持，包括促进您与其他用户和客户之间的关系，用户有权自行选择是否提交及公开相应信息，但如果不提交或公开相关信息，可能导致在使用某些信息、资料或服务时受到一定限制，此外用户通过本网站及软件完成请求服务或交易必需的情形下，应允许我们向正当第三方提供适当合理的信息。
            </span>
          </div>
          <div>
            <span
              >（三）用户浏览使用“小包公”及相关服务时，某些信息包括但不限于IP地址、访问日期、页面等，可能会通过互联网协议地址、cookies、网址标签以及导航数据采集等各种技术和方法被采集。“小包公”将主要基于改善本网站内容、更好的提供订制化或其他服务、更有效信息交流以及其他本隐私政策所列明的目的合理使用相关信息。</span
            >
          </div>
          <div><span>（四）在以下情形，可能根据国家相关规定披露您的信息：</span></div>
          <div style="padding-left:14px;">
            <span
              >1、您的行为违反了互联网相关法律法规的规定，或可能损害或妨碍其他用户的权益时，披露您的个人信息是为了辨识、联络或采取法律行动所必需时；</span
            >
          </div>
          <div style="padding-left:14px;"><span>2、按法律规定或涉及司法或政府的调查而披露；</span></div>
          <div style="padding-left:14px;"><span>3、法律法规所规定的其他必须披露个人信息的情形。</span></div>
        </div>
        <div class="agreement-body" v-if="mode === 'register'">
          <span
            >本服务协议是广东博维创远科技有限公司与您在协商一致的基础上，就“小包公”平台（以下简称“小包公”）及服务所订立的有效合约。
          </span>
          <p>一、服务内容</p>
          <div>
            <span
              >（一）广东博维创远科技有限公司在服务期限内授权用户按照本协议约定的方式使用“小包公”服务。用户在“小包公”点击“注册”按钮，即承认用户已阅读、理解本服务协议所有条款以及“小包公”所包含的各项指引、规则、政策、法律声明，并同意受其约束；且视为用户确认自己具有享受“小包公”服务、进行消费、签署合同等相应的权利能力和行为能力，能够独立承担法律责任。</span
            >
          </div>
          <div>
            <span
              >（二）用户注册的账号所有权归“小包公”所有，用户只有使用权。“小包公”享有在中华人民共和国大陆地区施行之法律允许的范围内独自决定拒绝服务、关闭注销用户账户、
              清除或编辑内容或取消订单的权利。</span
            >
          </div>
          <div>
            <span
              >（三）用户在注册时应提供完整、详尽、真实的个人资料，若所提供的资料日后有变更，用户应及时登录账号进行更新。若用户在“小包公”留下的个人资料与事实不符，“小包公”可以停止向其继续提供产品和服务。当用户向“小包公”主张其拥有某账号时，若该账号在“小包公”的身份信息记录与用户的身份信息有任何不符，“小包公”有权不予认定该账号为该用户所有。</span
            >
          </div>
          <div>
            <span
              >（四）根据国家法律法规变化及网络运营需要，“小包公”可在不事先通知用户的情况下，修改本协议下的条款和条件或单独条款和条件。
              一旦“小包公”将这些修改后的条款和条件或单独条款和条件登载公示在“小包公”上即生效，并代替原来的协议。用户如继续使用本服务，
              则应被视为对修改后的条款和条件或单独条款和条件给予有效而不可撤消的同意。用户在使用本服务时，应定期查阅这些条款和条件。
            </span>
          </div>
          <p>二、授权范围及限制</p>
          <div><span>（一）授权使用：“小包公”及其所含资料仅限于您以参考为目的使用（统称为“授权使用”）。</span></div>
          <div><span>（二）授权限制：</span></div>
          <div style="padding-left:14px;">
            <span> 1、不得对“小包公”全部或部分资料进行再发行、转发、出版、转让、商业或其他开发。</span>
          </div>
          <div style="padding-left:14px;">
            <span>
              2、不得通过对“小包公”资料系统提取或分析而直接或间接创建或编纂任何产品或作品，包括但不限于专辑、汇编、数据库、目录、期刊、论文等。
            </span>
          </div>
          <div style="padding-left:14px;">
            <span> 3、不得转让、共用、分享“小包公”的账户，“小包公”账户具有唯一性。</span>
          </div>
          <div style="padding-left:14px;"><span> 4、不得利用该系统从事违法犯罪、违背公序良俗的活动。</span></div>
          <div><span>（三）声明</span></div>
          <div style="padding-left:14px;">
            <span>
              1、“小包公”出具的报告、意见或解答，系根据法律法规、大数据分析得出，仅供用户参考，不代表司法机关的观点、结论。</span
            >
          </div>
          <div style="padding-left:14px;">
            <span>
              2、“小包公”对所涉具体案件的结果不做承诺，用户以“小包公”出具的报告、意见或解答与最终结果不同引起的纠纷，“小包公”不承担任何法律责任。</span
            >
          </div>
          <div style="padding-left:14px;">
            <span>
              3、“小包公”对专家论证报告不承担任何责任，用户知悉并同意专家论证报告对相关案件结果并不存在必然的影响。</span
            >
          </div>
          <div style="padding-left:14px;">
            <span>
              4、“小包公”仅作为第三方平台，为律师用户及其他用户提供技术帮助，“小包公”对于用户采购的具体法律服务不作任何承诺，不承担责任。</span
            >
          </div>
          <div style="padding-left:14px;">
            <span>
              5、“小包公”所提供的搜索结果因数据更新、技术等相关原因，可能存在滞后、模糊、不准确、中断等情况，“小包公”对此不承担任何责任。</span
            >
          </div>
          <p>三、服务费用和服务期限</p>
          <div>
            <span
              >“小包公”注册不收取服务费用，部分功能的服务费用和服务期限将在订购协议或订购的系统页面中予以列明，用户可自行选择服务类型并按列明的价格予以支付。</span
            >
          </div>

          <p>四、“小包公”的的权利、义务</p>
          <div>
            <span>（一）“小包公”应在现有技术上维护平台服务的正常进行，并努力提升技术及改进技术，使服务更好进行。</span>
          </div>
          <div>
            <span
              >（二）“小包公”可能包含指向其他网站或资源的超链接。“小包公”对通过这些链接而访问到的任何第三方资料或资源的内容不承担任何责任。用户与第三方发生的任何交易均与“小包公”无关，请查阅该链接网站的条款和条件以及隐私政策。</span
            >
          </div>
          <div>
            <span
              >（三）在未经“小包公”明示许可的情况下，用户不得将账号信息或访问账号的其他方式提供给任何未经“小包公”授权的单位或个人。同时，用户应对所有使用您的账号信息对“小包公”的访问负责。如果用户的账号已经泄漏，丢失或被盗，或者用户认为有泄露、丢失和被盗风险，请务必马上联系“小包公”工作人员。</span
            >
          </div>
          <div>
            <span
              >（四）“小包公”的所有信息材料是在基于现状的情况下提供给用户的，“小包公”不做任何形式的承诺和保证，对于用户参考“小包公”内容做出的一切行为，“小包公”不承担任何责任。</span
            >
          </div>

          <p>五、用户的的权利、义务</p>
          <div>
            <span
              >（一）不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论。</span
            >
          </div>
          <div><span>（二）不得利用“小包公”从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动。</span></div>
          <div><span>（三）不得干扰“小包公”的正常运转，不得侵入“小包公”及国家计算机信息系统。</span></div>
          <div><span>（四）不得教唆他人从事本条所禁止的行为。 </span></div>
          <div><span>（五）不得利用在“小包公”注册的账户进行牟利性经营活动。 </span></div>
          <div><span>（六）不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容。</span></div>
          <div>
            <span
              >（七）“小包公”保有删除各类不符合法律政策或不真实的信息内容而无须通知用户的权利。若用户未遵守以上规定的，“小包公”有权作出独立判断并采取暂停或关闭用户帐号等措施。用户须对自己在网上的言论和行为承担法律责任。</span
            >
          </div>
          <div>
            <span
              >（八）禁止以任何目的在“小包公”平台使用网络爬虫或其他自动下载程序或设备，包括但不限于从“小包公”获取未公开的数据、他人邮寄或邮件地址、发布商业广告。</span
            >
          </div>

          <p>六、免责声明</p>
          <div>
            <span
              >（一）“小包公”仅为用户查询相关法律信息资料提供内容上的参考，如需正式引用，请核对官方正式文本。如使用“小包公”提供的信息影响到您所进行的法律事务，致使其出现了您预期以外的困难或结果，“小包公”不承担任何责任。</span
            >
          </div>
          <div>
            <span
              >（二）“小包公”有权随时对软件及数据库的功能、结构和内容进行添加或者删改，而无须事先通知用户，“小包公”及其工作人员或其他关联人，对包括疏忽或其他原因所造成的信息资料的任何不当之处，均不承担责任。</span
            >
          </div>
          <div>
            <span
              >（三）访问“小包公”查看并下载或以其他形式获取“小包公”的任何材料，与此有关的风险由用户自行承担，对于因下载任何材料而发生电脑系统的任何损毁或数据损失，自行承担责任。</span
            >
          </div>
          <div>
            <span
              >（四）“小包公”可能包含指向其他网站或资源的超链接。“小包公”对通过这些链接而访问到的任何第三方资料或资源不承担任何责任。用户与第三方发生的任何交易均与“小包公”无关。</span
            >
          </div>

          <p>七、知识产权</p>
          <div>
            <span
              >（一）“小包公”产品及其衍生品相关的所有资料及源代码的知识产权属于广东博维创远科技有限公司。“小包公”向用户提供的任何内容、技术或技术支持、软件、服务等的知识产权均属于广东博维创远科技有限公司所有。用户无权复制、传播、转让、许可或提供他人使用上述资源。否则广东博维创远科技有限公司将追究用户相应的责任。</span
            >
          </div>
          <div>
            <span
              >（二）“小包公”所使用和显示的商标、服务标识、商品名称和标志归广东博维创远科技有限公司所有。用户不得以任何目的复制、仿造或使用或与之整体或部分相似的任何标志。</span
            >
          </div>
          <div><span>（三）未经“小包公”书面授权，任何人不得建立本网站的镜像（包括全部和局部镜像）。</span></div>

          <p>八、信息安全及保密</p>
          <div>
            <span
              >（一）用户应自行诚信向“小包公”提供注册资料，用户同意其提交的注册信息均真实、准确、及时、详尽和完整，并不断更新注册资料。不含有任何违反国家法律、法规及中华人民共和国承认或加入的国际条约的内容，且您通过“小包公”所从事的一切活动都是合法、真实的，不侵害任何第三方的合法权益。否则，用户应承担因此引起的相应责任及后果，并且“小包公”保留终止用户使用服务并追究用户赔偿损失的权利。
            </span>
          </div>
          <div>
            <span
              >（二）用户在“小包公”进行购买活动时，涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，“小包公”将予以严格保密。
            </span>
          </div>
          <div>
            <span
              >（三）用户注册成功后，将产生账号和密码等账户信息。用户应谨慎合理的保存、使用其账号和密码。“小包公”将凭密码进行的所有活动视为用户直接的行为。
            </span>
          </div>
          <div>
            <span
              >（四）用户同意，“小包公”拥有通过邮件、短信、电话等形式，向在“小包公”注册、购买的用户发送订单信息、促销活动等告知信息的权利。
            </span>
          </div>
          <div>
            <span
              >（五）用户不得将在“小包公”注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。
            </span>
          </div>
          <div>
            <span
              >（六）用户使用“小包公”为任何第三方提供服务的，对于用户和第三方之间的纠纷，“小包公”将不承担任何责任。
            </span>
          </div>
          <div>
            <span
              >（七）用户同意，在需要进行司法协助时，“小包公”有权使用用户的注册信息、账号、密码等信息，登陆进入用户的注册账户，进行证据保全，包括但不限于公证、见证等。</span
            >
          </div>

          <p>九、违约情形</p>
          <div>
            <span
              >（一）用户同意保障和维护“小包公”及其他用户的利益，如因用户违反有关法律、法规或本用户协议项下的任何条款而给“小包公”或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。</span
            >
          </div>
          <div>
            <span
              >（二）用户同意补偿广东博维创远科技有限公司及其关系企业、受雇人、及一切相关人员，因用户违反相关法律法规或本用户协议所产生之一切损害及责任。</span
            >
          </div>

          <p>十、争议解决</p>
          <div>
            <span
              >（一）凡因本协议而产生的争议，双方应友好协商解决。协商解决不成的，各方均同意将争议提交广州仲裁委员会网络仲裁解决，适用《中国广州仲裁委员会网络仲裁规则》。</span
            >
          </div>
          <div><span>（二）双方将以下手机号码或E-mail作为仲裁案件及接收另一方通知的电子送达地址：</span></div>
          <div><span>广东博维创远科技有限公司的联系方式：以工商登记信息为准。</span></div>
          <div><span>用户的联系方式：以用户在“小包公”绑定的信息为准。</span></div>

          <p>十一、送达</p>
          <div>
            <span
              >本用户协议项下所有的通知均可通过“小包公”平台重要页面公告、电子邮件等方式进行。该等通知于发送之日视为已送达收件人。</span
            >
          </div>

          <p>十二、其他</p>
          <div><span>（一）本协议自用户注册之时起生效。</span></div>
          <div>
            <span
              >（二）如本协议中的任何内容无论因何种原因完全或部分无效或不具有执行力，本协议的其余内容仍应有效并且对协议各方有约束力。</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'register'
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    },
    title() {
      if (this.mode === 'register') {
        return '“小包公”用户注册服务协议';
      }
      if (this.mode === 'privacy') {
        return '“小包公”隐私政策';
      }
      return '提示';
    }
  },
  watch: {
    async show(val) {
      if (!val) {
        return;
      }
      await this.$nextTick();
      window.document.getElementById('tipContent').scrollTop = 0;
    }
  },
  methods: {
    closeHandle() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@function rem($px) {
  @return $px * 0.1rem;
}

.tip-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#000, 0.6);
  }

  .container {
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    width: rem(300);
    border-radius: rem(4);
    z-index: 10;
    padding: rem(14) rem(18);

    .tip-content-ul {
      min-height: rem(100);
      max-height: 60vh;
      overflow: auto;
      margin-top: rem(14);

      .agreement-body {
        line-height: rem(22);
        h4 {
          font-size: rem(18);
          color: #222;
          margin-bottom: rem(20);
        }
        span {
          font-size: rem(14);
          color: #666;
        }
        p {
          font-size: rem(16);
          color: #222;
          margin: rem(15) 0;
        }
      }
    }

    .header {
      position: relative;
      height: rem(24);
      line-height: rem(24);
      padding-right: rem(21);

      .title {
        color: #222222;
        font-size: rem(17);
      }

      .close-btn {
        position: absolute;
        top: rem(-2);
        right: rem(-2);
        padding: rem(2);
        .iconfont {
          font-size: rem(12);
          color: #3d465a;
        }
      }
    }
  }
}
</style>
